import {domainResolutionServices} from '@/content/service-request/domainResolution'
import {prices} from '@/utils/pricing/prices'

import {PricesGroup} from '../pricing'
import {legalServices} from '../service-request/constants'
import {SupportedServices} from './types'

export type Service = {
  key: string
  imageSrc?: string
  imageAlt?: string
  title: string
  description?: string
  linkUrl?: string
  priceNote?: string
  tooltipText?: string
  group?: string
}

export const services: Record<SupportedServices, Service[]> = {
  Legal: legalServices,
  DomainResolution: domainResolutionServices,
}

export const getServicePrices: () => Record<SupportedServices, PricesGroup<string>> = () => ({
  Legal: prices.otherServiceMargins,
  DomainResolution: prices.otherServiceMargins,
})
